import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import portfolioData from '../../data/portfolioData';
import Reveal from '../Reveal/Reveal';
import './Experience.css';

const Experience = () => (
  <section className="section experience" id="experience">
    <div className="container">
      <Reveal>
        <div className="section-head">
          <p className="section-eyebrow">Experience</p>
          <h2 className="section-title">Where I've built</h2>
          <p className="section-lead">
            From banking infrastructure to production mobile platforms and AI workflows.
          </p>
        </div>
      </Reveal>

      <div className="experience__list">
        {portfolioData.experiences.map((job, index) => (
          <Reveal key={`${job.company}-${job.date}`} delay={(index % 3) + 1}>
            <article className="experience__item">
              <div className="experience__meta">
                <p className="experience__date">{job.date}</p>
                {job.location && <p className="experience__location">{job.location}</p>}
              </div>

              <div className="experience__body">
                <h3>{job.title}</h3>
                <p className="experience__company">{job.company}</p>
                <ul>
                  {job.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>

                <div className="experience__links">
                  {job.link && (
                    <a href={job.link.href} target="_blank" rel="noreferrer">
                      {job.link.label}
                      <OpenInNewIcon fontSize="inherit" />
                    </a>
                  )}
                  {job.links?.map((link) => (
                    <a key={link.href} href={link.href} target="_blank" rel="noreferrer">
                      {link.label}
                      <OpenInNewIcon fontSize="inherit" />
                    </a>
                  ))}
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
